import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'
import { DragIndicator } from '@mui/icons-material'
import { useTheme, IconButton, Card, CardContent, Grid, Typography } from '@mui/material'
import PropTypes from 'prop-types'

const SortableItem = ({ id, fieldId, children }) => {
    const { attributes, listeners, setNodeRef, transform, transition } = useSortable({ id })

    const theme = useTheme()

    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
        width: '100%'
    }

    return (
        <Card ref={setNodeRef} variant='outlined' style={style}>
            <CardContent>
                <Grid container alignItems='baseline'>
                    <Grid item xs sx={{ flexGrow: 1 }}>
                        {children}
                    </Grid>
                    <Grid item xs='auto'>
                        <IconButton {...attributes} {...listeners} style={{ cursor: 'grab' }}>
                            <DragIndicator />
                        </IconButton>
                    </Grid>
                </Grid>
                <Grid container justifyContent='flex-end'>
                    <Grid item>
                        <Typography variant='caption' color={theme.palette.text.secondary}>
                            {fieldId}
                        </Typography>
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    )
}

SortableItem.propTypes = {
    id: PropTypes.string.isRequired,
    fieldId: PropTypes.string.isRequired,
    children: PropTypes.node.isRequired
}

export default SortableItem